/* eslint-disable no-undef */
import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'store/redux.store'
import classNames from 'classnames'

import { ACTION, CATEGORY, DataLayer, EVENT, GoogleAnalyticsDataLayer } from 'src/utils/google-analytics'
import { CONTEXT_BAR_TYPES } from 'src/modules/context'
import { useShowSideMenuBasedOnRouteChanges } from '../sidemenu/hooks'

import SidemenuMobile from '../sidemenu/sidemenu-mobile.component'
import MenuUser from './menu/user/user.component'
import MenuDynamic from './menu/dynamic/dynamic.component'
import MenuNotification from './menu/notification/notification.component'
import MenuChat from './menu/chat/chat.component'
import CollaboratorsArea from './menu/collaborators-area/collaborators-area.component'
import PlatformToggle from './menu/platform-toggle/platform-toggle.component'
import AttendantLogoutButton from './menu/attendant/attendant-logout-button'
import AttendantHeaderLogo from './menu/attendant/attendant-header-logo'

import './header.styles.scss'

const Header = () => {
  let tabIndex = 1
  const context = useSelector(state => state.context)
  const user = useSelector(state => state.user)
  const showSideMenu = useShowSideMenuBasedOnRouteChanges()
  const getNextTabIndex = () => (tabIndex += 1)
  const logoClickHandler = () => {
    const dataLayer = new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_LOGO, 'home-dashboard')

    GoogleAnalyticsDataLayer.sendPageInteraction(dataLayer)
  }

  const isAttendant = context?.barType === CONTEXT_BAR_TYPES.ADM

  const barClassName = classNames('hot-application', {
    'hot-application--black': context?.barType === CONTEXT_BAR_TYPES.BLACK,
    'hot-application--custom-logo hot-application--attendant': isAttendant
  })

  return user ? (
    <hot-header class={barClassName}>
      <Link slot="logo-link" className="logo-link" to="/" onClick={logoClickHandler}>
        Hotmart
      </Link>
      {showSideMenu && <SidemenuMobile tabIndex={getNextTabIndex()} />}
      {isAttendant ? (
        <>
          <AttendantHeaderLogo />
          <MenuDynamic tabIndex={getNextTabIndex()} />
          <AttendantLogoutButton tabIndex={getNextTabIndex()} />
        </>
      ) : (
        <>
          <PlatformToggle tabIndex={getNextTabIndex()} />
          <CollaboratorsArea tabIndex={getNextTabIndex()} />
          <MenuChat tabIndex={getNextTabIndex()} />
          <MenuNotification tabIndex={getNextTabIndex()} />
          <MenuDynamic tabIndex={getNextTabIndex()} />
          <MenuUser tabIndex={getNextTabIndex()} />
        </>
      )}
    </hot-header>
  ) : null
}

export default React.memo(Header)
